import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsCtx = createContext({
  settings: null,
  loading: true,
  refetch: async () => {},
});

const FALLBACK = {
  company_name: "Auromine Retail POS Private Limited",
  company_address: "Chennai, Tamil Nadu, India",
  general_email: "hello@mineai.io",
  support_email: "support@mineai.io",
  support_phone: "",
  whatsapp_number: "+919876543210",
  whatsapp_default_message: "Hi Mine AI team, I have a question about ___",
  instagram_url: "",
  twitter_url: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings({ ...FALLBACK, ...r.data.settings });
    } catch {
      setSettings(FALLBACK);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <SettingsCtx.Provider value={{ settings, loading, refetch }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
